module.exports = __webpack_public_path__ + "img/nombre-apellido.72fd36db.png";